import {
  PurchasePlanActions,
  ResponseActions,
  ResponseDenialReasons,
} from './rfp-permissions.interfaces';

class BasePermissions<TAction, TDenialReason> {
  protected permissions!: any; //TPermission<TAction, TDenialReason>[];
  protected context: string;
  constructor(context: string) {
    this.context = context;
  }

  arePermissionsLoaded() {
    return !!this.permissions;
  }

  setPermissions(permissions: any) {
    this.permissions = permissions;
  }

  private findPermission(actionName: TAction) {
    const permissionObj = this.permissions[this.context] || this.permissions;
    return permissionObj[actionName];
  }

  isActionAllowed(actionName: TAction) {
    const permissionObj = this.findPermission(actionName);
    return permissionObj && permissionObj.hasAccess;
  }

  public getDenialReason(actionName: TAction): TDenialReason | null {
    const permission = this.findPermission(actionName);
    if (permission) {
      return permission.reasonForDenial;
    } else {
      return null;
    }
  }
}
export class ResponsePermissions extends BasePermissions<
  ResponseActions,
  ResponseDenialReasons
> {
  constructor(context: string) {
    super(context);
  }

  canAddOffer() {
    return this.isActionAllowed('ADD_OFFER');
  }

  canUpdateOffer() {
    return this.isActionAllowed('UPDATE_OFFER');
  }

  canRemoveOffer() {
    return this.isActionAllowed('REMOVE_OFFER');
  }

  canUpdateOfferPricing() {
    return this.isActionAllowed('UPDATE_OFFER_PRODUCT_PRICES');
  }

  canSubmitOffer() {
    return this.isActionAllowed('SUBMIT_OFFERS');
  }

  canViewOfferImpact() {
    return this.isActionAllowed('VIEW_OFFER_IMPACT');
  }

  canRetractResponse() {
    return this.isActionAllowed('RETRACT_OFFERS');
  }

  canModifyAttachments() {
    return this.isActionAllowed('MODIFY_ATTACHMENT');
  }

  canModifyOfferTier() {
    return this.isActionAllowed('MODIFY_OFFER_TIER');
  }
}

// This is a techdebt that is being worked in FEND-1076. This should be moved from response nav folder to
// a shared folder
export class PurchasePlanPermissions extends BasePermissions<
  PurchasePlanActions,
  ResponseDenialReasons
> {
  constructor(context: string) {
    super(context);
  }

  canViewPartnerPlan() {
    return this.isActionAllowed('VIEW_PARTNER_PLAN');
  }

  canChangeMarketShare() {
    return this.isActionAllowed('CHANGE_MARKET_SHARE');
  }

  canSavePlan() {
    return this.isActionAllowed('SAVE_PURCHASE_PLAN');
  }
}
